module.exports = __webpack_public_path__ + "static/media/gem2.9f815c0d.png";